import React from "react";
import { ManagerTeamComponent } from "features/team";
function Team(props) {
  return <ManagerTeamComponent />;
}

export default Team;
